export const nettoyerReponsePourRapport = (texte) => {
  if (!texte || typeof texte !== 'string') return '';

  let r = texte;

  // Blocs de code ``` ... ```
  r = r.replace(/```[\s\S]*?```/g, '');

  // Code inline `code`
  r = r.replace(/`([^`]+)`/g, '$1');

  // Titres markdown # à ######
  r = r.replace(/^#{1,6}\s+/gm, '');

  // Gras ** et __
  r = r.replace(/\*\*([^*]+)\*\*/g, '$1');
  r = r.replace(/__([^_]+)__/g, '$1');

  // Normaliser puces de liste (* item → - item) avant suppression italique
  r = r.replace(/^(\s*)\*\s+/gm, '$1- ');

  // Italique * et _ (hors listes déjà normalisées)
  r = r.replace(/\*([^*\n]+)\*/g, '$1');
  r = r.replace(/_([^_\n]+)_/g, '$1');

  // Liens [texte](url) → texte
  r = r.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  // Compacter les sauts de ligne multiples
  r = r.replace(/\n{3,}/g, '\n\n');

  r = r.trim();

  // Limiter à ~1000 caractères
  const LIMITE = 1000;
  if (r.length > LIMITE) {
    let coupe = r.substring(0, LIMITE);
    const dernierEspace = coupe.lastIndexOf(' ');
    if (dernierEspace > 800) coupe = coupe.substring(0, dernierEspace);
    r = coupe + ' [...]';
  }

  return r;
};
